import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SubmissionDetailsFieldChange } from '../submission-details-field-changes/submission-details-field-change';
import { SubmissionDetailsFieldChangeTypeEnum } from '../submission-details-field-changes/submission-details-field-change-type.enum';

@Component({
  selector: 'app-employer-contact-submission-details-field-change',
  templateUrl: './employer-contact-submission-details-field-change.component.html',
  styleUrls: ['./employer-contact-submission-details-field-change.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerContactSubmissionDetailsFieldChangeComponent implements OnChanges {
  @Input() detailsChanges: SubmissionDetailsFieldChange[] = [];
  @Input() changeType!: SubmissionDetailsFieldChangeTypeEnum;

  public label: string = '';
  public hasChanges: boolean = true;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.changeType) {
      this.label =
        this.changeType === SubmissionDetailsFieldChangeTypeEnum.Previous ? $localize`Previous` : $localize`New`;
    }
    if (changes.detailsChanges) {
      this.hasChanges = this.detailsChanges?.some(change => change.hasChanges);
    }
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
